import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { FaqCta } from '@/components/FaqCta';
import { FAQ_ITEM_SLOT } from '@/content/home-cta/copy';
import { useLandingSectionTracking } from '@/hooks/useLandingSectionTracking';
import { useTranslation } from '@/i18n/i18n';

export const FAQ = () => {
  const sectionRef = useLandingSectionTracking('faq');
  const { t } = useTranslation();

  const faqs = [
    { id: 'q1', question: t('faq.q1'), answer: t('faq.a1') },
    { id: 'q2', question: t('faq.q2'), answer: t('faq.a2') },
    { id: 'q3', question: t('faq.q3'), answer: t('faq.a3') },
    { id: 'q4', question: t('faq.q4'), answer: t('faq.a4') },
    { id: 'q5', question: t('faq.q5'), answer: t('faq.a5') },
    { id: 'q6', question: t('faq.q6'), answer: t('faq.a6') },
    { id: 'q7', question: t('faq.q7'), answer: t('faq.a7') },
    { id: 'q8', question: t('faq.q8'), answer: t('faq.a8') },
    { id: 'q9', question: t('faq.q9'), answer: t('faq.a9') },
  ];

  return (
    <section ref={sectionRef} id="faq" aria-labelledby="faq-heading" className="py-16 px-6 md:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 id="faq-heading" className="text-3xl md:text-5xl font-semibold mb-4">
            {t('faq.heading')}
          </h2>
          <p className="text-lg text-muted-foreground">{t('faq.subheading')}</p>
        </div>

        {/* FAQ accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.question}
              value={faq.question}
              className="border-2 rounded-lg px-6 bg-card"
            >
              <AccordionTrigger className="text-left font-semibold hover:no-underline py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                {faq.answer}
                {FAQ_ITEM_SLOT[faq.id] && <FaqCta slot={FAQ_ITEM_SLOT[faq.id]} />}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
